<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction" />
    <div class="inner">
      <p class="paging">
        <router-link :to="{ name: 'vodVideos' }" class="btn btn_back" v-translate>Seznam</router-link>
      </p>
      <h1 id="vodProviderH1" v-translate>Detail série</h1>
    </div>
    <div class="inner_white">
      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="vod-episodes-list">
          <table class="vypis vypis_detail">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"/>
              <th class="no_padding checkbox"/>
              <sorting-table-title
                  v-for="title in tableTitles"
                  :key="title.key"
                  :column="title.column"
                  :sortable="title.sortable"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"/>
            </tr>
            </thead>

            <vod-episodes-row
                v-for="entity in entities"
                :entity="entity"
                :key="entity.id"
                @input="select"
                :selectedEntities="selectedEntities"
                :ref="'vod-providers-row-ref-'+entity.id"
            ></vod-episodes-row>

            <tr v-if="entities.length === 0">
              <td colspan="3">{{ $gettext('Nebyly nalezeny žádné epizody série.') }}</td>
            </tr>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="vod-episodes-list"
          @run-multiple-action="runMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          @select-all="toggleSelectAll"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import VodEpisodesRow from "./VodEpisodesRow.vue";
import listActions from "@/components/mixins/list-actions"

export default {
  name: "VodProviders",
  components: {
    VodEpisodesRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'vodProviders',
      entitiesKey: 'vodEpisodes',
      formFields: {
        id_show: this.$route.params.id,
        sort: {
          column: 'sName',
          direction: 'desc',
        },
      },
    }
  },
  created(VodEpisodeService) {
    this.entityService = VodEpisodeService;

    this.createdInit();
  },
  computed: {
    tableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Série a epizoda'), column: 'sName'},
        {key: 3, name: this.$gettext('Věkové omezení'), column: 'sMaturityRating'},
        {key: 4, name: this.$gettext('Poskytovatel videa'), column: 'sVodProviderName'},
        {key: 5, name: this.$gettext('Balíčky'), column: 'sVodProviderName',sortable: false},
        {key: 6, name: this.$gettext('Stav zpracování na zdroji'), column: 'sSourceState'},
        {key: 7, name: this.$gettext('Stav lokálního zpracování'), column: 'sLocalState'},
        {key: 8, name: this.$gettext('Délka'), column: 'sDurationSeconds'},
        {key: 9, name: this.$gettext('Poskytováno od'), column: 'sProvidedFrom'},
        {key: 10, name: this.$gettext('Poskytováno do'), column: 'sProvidedTo'},
      ];
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.tableTitles)
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodEpisodes/VodEpisodesList.vue